import axios from 'axios';

const BACKEND_ENDPOINT = 'https://api.emet.live';

const backend = axios.create({
  withCredentials: true,
  baseURL: BACKEND_ENDPOINT,
  timeout: 30000,
});

export async function registerUser({ ethAddress, name, email, web, locale }) {
    const payload = { eth_address: ethAddress, name, email, web, locale };
    try {
        return await backend.post(`${BACKEND_ENDPOINT}/user/create`, payload);
    } catch(error) {
        throw error.response.data;
    }
}

export async function confirmUser({ ethAddress, code }) {
    try {
        return await backend.get(`${BACKEND_ENDPOINT}/user/${ethAddress}/confirm/${code}`);
    } catch(error) {
        throw error.response.data;
    }
}
